// src/components/TestimonialSlider.tsx
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import TestimonialCard from './TestimonialCard';
import 'swiper/css';
import 'swiper/css/pagination';

interface Testimonial {
	id: string;
	company: string;
	description: string;
	logo: string;
	name: string;
	position: string;
}

interface TestimonialSliderProps {
	testimonials: Testimonial[];
	autoplayDelay?: number;
	spaceBetween?: number;
}

const TestimonialSlider: React.FC<TestimonialSliderProps> = ({
	testimonials,
	autoplayDelay = 3000,
	spaceBetween = 24
}) => {
	if (!testimonials || testimonials.length === 0) {
		return (
			<div className="container">
				<div className="w-full flex justify-center py-20">
					<p className="text-gray-300">No testimonials available</p>
				</div>
			</div>
		);
	}

	return (
		<div className="w-full flex justify-center py-8 md:py-6">
			<Swiper
				modules={[Pagination, Autoplay]}
				spaceBetween={spaceBetween}
				slidesPerView={1}
				pagination={{ clickable: true }}
				autoplay={{
					delay: autoplayDelay,
					disableOnInteraction: false,
				}}
				breakpoints={{
					1024: {
						slidesPerView: Math.min(2, testimonials.length),
					},
					1400: {
						slidesPerView: Math.min(3, testimonials.length),
					},
				}}
				className="max-w-6xl custom-swiper-carousel"
			>
				{testimonials.map((testimonial) => (
					<SwiperSlide key={testimonial.id} className="testimonial-slide flex justify-center">
						<TestimonialCard testimonial={testimonial} />
					</SwiperSlide>
				))}
			</Swiper>

			<style>{`
				.custom-swiper-carousel .swiper-wrapper {
					align-items: stretch;
				}
				.testimonial-slide {
					height: auto;
					display: flex;
				}
			`}</style>
		</div>
	);
};

export default TestimonialSlider;